import * as Yup from 'yup';

export const SendRetencaoValidation = Yup.object({
  email: Yup.string().email('Insira um e-mail válido')
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Insira um e-mail válido').required('Digite seu e-mail'),
  tel: Yup.string().min(14, 'Insira um telefone válido').required('Digite seu telefone')
});